/* RESPONSIBLE TEAM: team-workflows */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';
import { get } from 'embercom/lib/ajax';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
import { FinGettingStartedState } from 'embercom/lib/reporting/fin-getting-started-states';
import storage from 'embercom/vendor/intercom/storage';

export default class AutomationRoute extends Route {
  @service store;
  @service appService;
  @service router;
  @service contentImportService;
  @service outboundHomeService;
  @service permissionsService;
  @service reportingMetrics;

  gettingStarted = new FinGettingStartedState(this);

  get app() {
    return this.appService.app;
  }

  activate() {
    storage.set('lastProductUsed', 'automation.fin-ai-agent');
  }

  async beforeModel(transition) {
    await this.reportingMetrics.setup.perform();
    if (
      this.app.canUseAccessFinAndAutomationSettingsPermission &&
      !this.app.canUseFeature('fin-automation-settings-permission-killswitch')
    ) {
      this.permissionsService.ensurePermissionWhenTransitioning(
        'can_access_fin_and_automation_settings',
        transition,
        'apps.app',
      );
    }
  }

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-workflows',
    };
  }

  async loadDescriptors() {
    // We don't want to fail the page load in case this ever goes wrong
    try {
      await this.store.findAll('conversation-attributes/descriptor');
    } catch (e) {
      console.error(e);
    }
  }

  async model() {
    this.contentImportService.fetchContentIngestionState();
    this.contentImportService.fetchAiContentLibrarySummary();
    this.contentImportService.fetchContentReviewSummary();
    await this.loadDescriptors();

    let counts = {};
    let gettingStartedState = null;
    // We don't want to fail the page load in case this ever goes wrong
    try {
      let { answers } = await get(`/ember/operator_workflows/workflow_counts`, {
        app_id: this.app.id,
      });

      let profiles = await this.outboundHomeService.contentSearch({
        object_types: [objectTypes.resolutionBotBehavior],
        app_id: this.app.id,
      });
      counts = {
        answers,
        profiles: profiles.totalCount,
      };
    } catch (e) {
      console.error(e);
    }
    try {
      gettingStartedState = await this.gettingStarted.getState();
    } catch (e) {
      console.error(e);
    }

    let [lookAndFeel, availability, upfrontEmailCollection] = await Promise.all([
      this.store.findRecord('messenger-settings/look-and-feel', this.app.id),
      this.store.findRecord('messenger-settings/availability', this.app.id),
      this.store.findRecord('messenger-settings/upfront-email-collection', this.app.id),
    ]);

    return hash({
      lookAndFeel,
      availability,
      upfrontEmailCollection,
      counts,
      gettingStartedState,
    });
  }

  setupController(controller, model) {
    super.setupController(...arguments);
    controller.initializeConfigurationModel();
  }
}
